// External libraries
import { useReducer } from 'react';
import { useStoreState } from '@/store';

// Internal Modules
import { reducer } from './reducer';
import { DOES_NOT_PAY_TAXES_OUTSIDE_COUNTRY } from '@/components/CRSFields/constants';

/**
 * @description: Hook for CRSForm
 *  For CRS data collection, we are keeping all the state local.
 * We are only updating the global state once the user clicks on continue
 * and all fields pass validations (createAccountHandler)
 * @returns {Array}  [state, dispatch]
 */
export const useCRSReducer = () => {
  const crsTaxStatus = useStoreState(({ form }) => form.crsTaxStatus);
  const crsTaxDetails = useStoreState(({ form }) => form.crsTaxDetails.value);
  const crsLegalFirstName = useStoreState(({ form }) => form.crsLegalFirstName);
  const crsLegalLastName = useStoreState(({ form }) => form.crsLegalLastName);

  const initialState = {
    crsLegalFirstName,
    crsLegalLastName,
    crsTaxDetails,
    crsTaxStatus: {
      ...crsTaxStatus,
      // Default value to doesNotPayTaxesOutsideCountry to pre-select option for user
      value: crsTaxStatus.value || DOES_NOT_PAY_TAXES_OUTSIDE_COUNTRY,
    },
  };

  return useReducer(reducer, initialState);
};
